import { useEffect, useMemo, useState } from "react";
import {
  NavigateFunction,
  Outlet,
  useLocation,
  useNavigate,
  Location,
} from "react-router-dom";
import AuthService from "../../services/auth";
import ROUTES from "../../configs/routesConfig";
import _ from "lodash";
import MetaService from "../../services/meta";
import { useAppDispatch } from "../../store";
import { setMetaData } from "../../acions/actionsCreators/metaData";
import { useSelector } from "react-redux";
import { useGetRole } from "../hooks/getRole";
import USER_ROLES from "../../types/UserRoles";

export const RedirectHome = () => {
  const navigate: NavigateFunction = useNavigate();

  const location: Location = useLocation();

  const dispatch = useAppDispatch();

  const metaData = useSelector((state: any) => state.metaData);

  const [role] = useGetRole();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const canViewDashboard: boolean = useMemo(() => {
    return metaData.featureFlags && metaData.featureFlags.Dashboard;
  }, [metaData]);

  const isAdminScope: boolean = useMemo(
    () => [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(role),
    [role],
  );

  useEffect(() => {
    MetaService.fetchData()
      .then((res) => {
        dispatch(setMetaData(res));
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [dispatch]);

  const title: string = useMemo(() => {
    const root = location.pathname.split("/")[1].split("-");

    const res: string = root
      .map((item: string) => _.capitalize(item))
      .join(" ");

    return `${res}${metaData.companyName ? " - " + metaData.companyName : ""}`;
  }, [location, metaData]);

  const redirectPath: string = useMemo(() => {
    let path: string;

    if (AuthService.isLoggedIn()) {
      if (canViewDashboard && isAdminScope) {
        path = ROUTES.DASHBOARD;
      } else if (role === USER_ROLES.INTEGRATION_RECEPTIONIST) {
        path = ROUTES.PROFILE;
      } else {
        path = ROUTES.ACCOUNTS;
      }
    } else {
      path = ROUTES.LOGIN;
    }

    return path;
  }, [canViewDashboard, isAdminScope, role]);

  useEffect(() => {
    document.title = title;

    if (location.pathname === ROUTES.DASHBOARD && !isAdminScope) {
      navigate("/not-found");
    }

    if (location.pathname === ROUTES.HOME && canViewDashboard !== undefined) {
      navigate(redirectPath);
    }
  }, [canViewDashboard, location, navigate, title, redirectPath, isAdminScope]);

  return <>{!isLoading ? <Outlet /> : <></>}</>;
};
